import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuoteAdvancedFiltersUsedParameters extends TrackEventBaseParameters<null, "filter_name"> {}

const trackQuoteAdvancedFiltersUsed = (
    parameters: TrackQuoteAdvancedFiltersUsedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "quote_advanced_filters_used", ...parameters }, options);
};

export default trackQuoteAdvancedFiltersUsed;
